import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","TermsAndConditionsPolicyDataId"] */ "/codebuild/output/src2482288207/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
